import { dao } from '@platform/dao';
import type { IWorkspaceDirectory } from '@platform/dao';
import { baseApi, run } from './baseApi';

/**
 * Каталог робочих просторів платформи (Адміністрування › Робочі простори, навігатор просторів): усі простори з учасниками, модулями й моєю
 * роллю; запит доступу до чужого простору оновлює каталог (позначка «Доступ запитано»).
 */
export const directoryApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    workspaceDirectory: b.query<IWorkspaceDirectory, void>({ queryFn: () => run(() => dao.workspaces.directory()), providesTags: ['Workspaces'] }),
    requestAccess: b.mutation<unknown, { ws: string; note?: string }>({ queryFn: ({ ws, note }) => run(() => dao.workspaces.requestAccess(ws, note)), invalidatesTags: ['Workspaces'] }),
  }),
});

export const { useWorkspaceDirectoryQuery, useRequestAccessMutation } = directoryApi;
